export default __webpack_public_path__ + "static/media/flayer1.c51f8c74.jpg";